import script from "./StoreProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreProductCard.vue?vue&type=script&setup=true&lang=ts"

import "./StoreProductCard.vue?vue&type=style&index=0&id=3994a9f5&lang=css"

const __exports__ = script;

export default __exports__